import React from 'react';
import './ContextBreadcrumb.css';

function ContextBreadcrumb({ community, business, onNavigate }) {
  return (
    <nav className="context-breadcrumb">
      <button 
        className="breadcrumb-item community"
        onClick={() => onNavigate('community')}
      >
        {community?.name || 'Community'}
      </button>
      
      {business && (
        <>
          <span className="separator">›</span>
          <span className="breadcrumb-item business current">
            {business.name}
          </span>
        </>
      )}
    </nav>
  );
}

export default ContextBreadcrumb;